var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.inventory
    ? _c(
        "div",
        [
          _vm.loading
            ? _c("CenterOnParent", [_c("Spinner")], 1)
            : _c(
                "div",
                [
                  _c("VueGoodTable", {
                    attrs: {
                      columns: _vm.columnsConfig,
                      rows: _vm.contactsForDisplay,
                      "pagination-options": _vm.paginationOptions,
                      "search-options": _vm.searchOptions
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "table-row",
                          fn: function(props) {
                            return [
                              props.column.field === "actions"
                                ? _c("div", { staticClass: "btn-group" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-sm btn-danger",
                                        on: {
                                          click: function($event) {
                                            return _vm.onContactRemove(
                                              props.row
                                            )
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-trash" })]
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(
                                          props.formattedRow[props.column.field]
                                        ) +
                                        "\n        "
                                    )
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3880114057
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success mt-2",
                      on: {
                        click: function($event) {
                          return _vm.$refs.modal.open()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-plus" })]
                  ),
                  _vm._v(" "),
                  _c("ContactSelectModal", {
                    ref: "modal",
                    attrs: { allContacts: _vm.availableContacts },
                    on: { selected: _vm.onContactsAdd }
                  })
                ],
                1
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }